import { pickGmwLibraryFields } from "../../../schema/gmw-schema-library";

import type { SourcedocumentDataSchemaFor } from "./_gmw-event-schema-collection";

export const gmwSubsequentAdditionalSurveySchema: SourcedocumentDataSchemaFor<"GMW_SubsequentAdditionalSurvey"> =
  {
    type: "object",
    title: "Gebeurtenis gegevens",
    required: ["eventDate", "relatedSurveys"],
    properties: pickGmwLibraryFields(["eventDate", "relatedSurveys"]),
  };
